import { render, staticRenderFns } from "./UserDetailsAdministrationTabsLockUserTable.vue?vue&type=template&id=49d17cf1&scoped=true&"
import script from "./UserDetailsAdministrationTabsLockUserTable.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAdministrationTabsLockUserTable.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsAdministrationTabsLockUserTable.vue?vue&type=style&index=0&id=49d17cf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d17cf1",
  null
  
)

export default component.exports